import { Injectable, signal, computed } from '@angular/core';
import { User } from '../../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserStore {
  readonly userSignal = signal<User | null>(null);
  readonly userIdSignal = computed(() => this.userSignal()?.userId);

  /**
   * Updates the user state
   */
  setUser(user: User): void {
    this.userSignal.set(user);
  }

  /**
   * Resets state
   */
  clearUser(): void {
    this.userSignal.set(null);
  }
}
